import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

export function Spinner({ size }) {
  return (
    <SpinnerWrapper style={{ width: size, height: size }}>
      <SpinnerArc />
    </SpinnerWrapper>
  );
}

Spinner.propTypes = {
  size: PropTypes.number,
};

Spinner.defaultProps = {
  size: 24,
};

// rotation
const rotate = keyframes`
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

// This creates a gray circle + one primary colored arc inside
const SpinnerArc = styled.div`
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  /* Outer thin circle */
  border: 4px solid ${({ theme }) => theme.colors.stroke};

  /* Only the top border becomes primary.main (inside color) */
  border-top-color: ${({ theme }) => theme.colors.primary.main};

  border-radius: 50%;
  animation: ${rotate} 0.8s linear infinite;
`;
